/**
 * This module defines a list of known server error codes that the client application expects to receive from the backend API.
 */
export const SERVER_ERROR_CODES = [
  "AUTH_UNAUTHENTICATED",
  "AUTH_INVALID_CREDENTIALS",
  "AUTH_FORBIDDEN",
  "VALIDATION_FAILED",
  "RESOURCE_NOT_FOUND",
  "BUSINESS_RULE_VIOLATION",
  "DATABASE_CONSTRAINT_VIOLATION",
  "DATABASE_QUERY_ERROR",
  "HTTP_ERROR",
  "INTERNAL_SERVER_ERROR",
] as const;



/**
 * A set of the SERVER_ERROR_CODES array.
 */
export const SERVER_ERROR_CODE_SET = new Set<string>(SERVER_ERROR_CODES);
